import { ApiClientType, ApiObservationFrequency } from '../../../../../../api/_legacy/generated-api'
import {
  FieldSet,
  FormItem,
  Label,
  Select,
  SliderWithTextInput,
  Space,
  Switch,
  SwitchWithLabel
} from '../../../../../../components/core-v2'
import { NumberField } from '../../../../types'
import { StrategyActions } from '../../state/strategy-slice'

type CoreProtectionEditorProps = {
  actions: StrategyActions
  clientType: ApiClientType
  commonState: {
    isApplyVolControl: boolean
    isBankGuarantee: boolean
    isHighWaterMark: boolean
  }
  isGeneratingCharts: boolean
  state: {
    highWaterMarkFrequency: ApiObservationFrequency
    leverageRatio: NumberField
    protectionLevel: NumberField
    targetVolatility: NumberField
  }
}

export function CoreProtectionEditor({
  actions,
  clientType,
  commonState,
  isGeneratingCharts,
  state
}: CoreProtectionEditorProps) {
  const isRetailClient = clientType === 'Retail'
  return (
    <Space mt={6}>
      <Space mb={5}>
        <FormItem>
          <Label>Bank protection</Label>
          <SwitchWithLabel
            data-testid="switch-bank-guarantee"
            isChecked={commonState.isBankGuarantee}
            isDisabled={isGeneratingCharts || isRetailClient}
            isDisabledShownAsUnavailable={false}
            labelPosition="right"
            onChange={isChecked => actions.setProtectionIsBankGuarantee(isChecked)}
          />
        </FormItem>
      </Space>
      <Space mb={5}>
        <FormItem>
          <Label>Do you want to apply Risk Managed?</Label>
          <SwitchWithLabel
            data-testid="switch-apply-volatility-control"
            isChecked={commonState.isApplyVolControl}
            isDisabledShownAsUnavailable={false}
            labelPosition="right"
            onChange={isChecked => actions.setProtectionIsApplyVolatilityControl(isChecked)}
          />
        </FormItem>
      </Space>
      {commonState.isApplyVolControl && (
        <FormItem>
          <Label>Target volatility (%)</Label>
          <SliderWithTextInput
            data-testid="target-volatility"
            max={state.targetVolatility.max}
            min={state.targetVolatility.min}
            step={0.25}
            value={state.targetVolatility.value}
            onChange={value => actions.setProtectionTargetVolatility(value)}
          />
        </FormItem>
      )}
      <Space mb={5}>
        <FormItem>
          <Label>Protection level (%)</Label>
          <SliderWithTextInput
            data-testid="protection-level"
            max={state.protectionLevel.max}
            min={state.protectionLevel.min}
            step={2.5}
            value={state.protectionLevel.value}
            onChange={value => actions.setProtectionLevel(value)}
          />
        </FormItem>
      </Space>
      <Space mb={5}>
        <FormItem>
          <Label>High Water Mark</Label>
          <FieldSet direction="horizontal">
            <Switch
              data-testid="switch-high-watermark"
              isChecked={commonState.isHighWaterMark}
              isDisabled={isGeneratingCharts}
              onChange={isChecked => actions.setProtectionHighWaterMark(isChecked)}
            />
            {commonState.isHighWaterMark && (
              <Select
                data-testid="high-watermark-frequency"
                value={state.highWaterMarkFrequency}
                onChange={e => actions.setProtectionHighWaterMarkFrequency(e.target.value)}
              >
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Quarterly">Quarterly</option>
                <option value="SemiAnnually">Semi annually</option>
                <option value="Annually">Annually</option>
              </Select>
            )}
          </FieldSet>
        </FormItem>
      </Space>
    </Space>
  )
}
